import Swal from "sweetalert2/dist/sweetalert2.min.js";

export const errorMessage = (text: string | null, confirmButtonText = "Try again!") => {
    return Swal.fire({
        text: text,
        icon: "error",
        buttonsStyling: false,
        confirmButtonText: confirmButtonText,
        customClass: {
            confirmButton: "btn fw-bold btn-dark-blue"
        }
    });
}

export const successMessage = (html: string | null) => {
    return Swal.fire({
        html: html,
        icon: "success",
        buttonsStyling: false,
        confirmButtonText: "Ok",
        customClass: {
            confirmButton: "btn fw-bold btn-dark-blue"
        }
    });
}

export const confirmMessage = (title: string, html: string, confirmButtonText = "Yes, delete it", cancelButtonText = "Cancel") => {
    return Swal.fire({
        title: title,
        html: html,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3b82f6",
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        buttonsStyling: false,
        customClass: {
            confirmButton: "btn fw-bold btn-danger",
            cancelButton: "btn fw-bold btn-primary"
        }
    });
}

export default {
    errorMessage,
};